<div class="login form-frame">
  <app-logo></app-logo>

  <div class="form-frame__body">
    <img
      src="assets/img/ok.svg"
      alt="OK"
      class="form-frame__body-icon">

    <h2
      class="form-frame__body-title">
      {{'RESET_PASSWORD_SUCCESS.DESCRIPTION' | translate}}
    </h2>

    <button
      routerLink="/login"
      class="btn btn-accent">
      {{'RESET_PASSWORD_SUCCESS.BUTTON' | translate}}
    </button>
  </div>

  <app-lang-select></app-lang-select>
</div>
